import { render, staticRenderFns } from "./MembershipOnboarding.vue?vue&type=template&id=470c84c3"
import script from "./MembershipOnboarding.vue?vue&type=script&lang=js"
export * from "./MembershipOnboarding.vue?vue&type=script&lang=js"
import style0 from "./MembershipOnboarding.vue?vue&type=style&index=0&id=470c84c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports